import {Component, Injector, Input, OnInit} from "@angular/core";
import {CustomObjectSearchModel} from "../custom-object-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    AbstractSelectSearchControlComponent
} from "../../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {CustomObjectSearchPageComponent} from "../custom-object-search-page/custom-object-search-page.component";
import {
    MembershipTypeCustomObjectSearchPageComponent
} from "../custom-object-search-page/membership-type-custom-object-search-page.component";
import {
    OutletCustomObjectSearchPageComponent
} from "../custom-object-search-page/outlet-custom-object-search-page.component";
import {
    InventoryCustomObjectSearchPageComponent
} from "../custom-object-search-page/inventory-custom-object-search-page.component";
import {
    ProductLineCustomObjectSearchPageComponent
} from "../custom-object-search-page/product-line-custom-object-search-page.component";
import {
    CustomObjectAssociationContext,
    CustomObjectTypeSearchModel
} from "../../custom-object-type/custom-object-type-search.model";
import {
    registerSearchControl
} from "../../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-custom-object-multi-select-search-control",
    templateUrl: "../../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        provideSearchModel(CustomObjectSearchModel),
        registerSearchControl(CustomObjectMultiSelectSearchControlComponent)
    ]
})
export class CustomObjectMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<CustomObjectSearchModel> implements OnInit {
    @Input() productLineContext: boolean;
    @Input() inventoryContext: boolean;
    @Input() outletContext: boolean;
    @Input() membershipTypeContext: boolean;

    constructor(model: CustomObjectSearchModel, injector: Injector) {
        super(model, injector, "customObjectId", "name");
    }

    ngOnInit(): void {
        if (this.productLineContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.PRODUCT_LINE;
            this.extendedSearchComponent = ProductLineCustomObjectSearchPageComponent;
        } else if (this.inventoryContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.INVENTORY;
            this.extendedSearchComponent = InventoryCustomObjectSearchPageComponent;
        } else if (this.outletContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.OUTLET;
            this.extendedSearchComponent = OutletCustomObjectSearchPageComponent;
        } else if (this.membershipTypeContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.MEMBERSHIP_TYPE;
            this.extendedSearchComponent = MembershipTypeCustomObjectSearchPageComponent;
        } else {
            this.extendedSearchComponent = CustomObjectSearchPageComponent;
        }
    }
}
